import Text from '@ui/text/text/text';
import toastTrigger from '@ui/toast/toast-trigger';
import CreateSpeakers from '../../helpers/cast-and-crew';
import { Session } from '@/types/session.types';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { useAppDispatch } from '@/store/hooks';
import { setSavingWorkingProject } from '@/store/slices/project';
import { Speaker } from '@/types/speakers.types';

const saveUpdatedCast = async ({
  session,
  defaultOptions,
  selectedOptions,
  dispatch,
}: {
  session?: Session | null;
  defaultOptions: TReactSelectOption[];
  selectedOptions: TReactSelectOption[];
  dispatch: ReturnType<typeof useAppDispatch>;
}) => {
  try {
    if (!session) return;

    const sortedDefaultIds = defaultOptions.map((o) => o.value).toSorted();
    const sortedSelectedIds = selectedOptions.map((o) => o.value).toSorted();
    if (JSON.stringify(sortedDefaultIds) === JSON.stringify(sortedSelectedIds)) {
      return;
    }

    dispatch(setSavingWorkingProject(true));

    const updatedOptions = selectedOptions.map((option) => option.meta).filter(Boolean) as Speaker[];

    await CreateSpeakers({
      speakers: updatedOptions,
      dispatch,
      session,
    });
  } catch (error) {
    console.error(error);
    toastTrigger(
      <Text color="var(--gray-true-dark-0)" className="P2">
        Error saving speakers, please refresh and try again.
      </Text>,
      {
        type: 'error',
        autoClose: 10000,
      }
    );
  }
};

export default saveUpdatedCast;
